const { ERROR_TAGS, errorTagsLocales } = require('./errorTags');
const {
  GENERIC_ERROR_MESSAGES,
  genericErrorMessagesLocales,
} = require('./genericErrorMessages');
const {
  BANK_IDENTITY_STATEMENT,
  BUSINESS_LEGAL_STATUS,
  COMPANY_REGISTRATION,
  DRIVER_LICENSE,
  DRIVER_LICENSE_HOST,
  FOURTHLINE_GENERIC_ID_DOCUMENT,
  FOURTHLINE_REPORT,
  GENERIC,
  ID,
  ID_DOCUMENT_OTHER_SHOT,
  ID_HOST,
  ID_RECTO,
  ID_RECTO_HOST,
  ID_VERSO,
  ID_VERSO_HOST,
  KYB_DOCUMENTS_TYPES,
  KYC_DOCUMENTS_TYPES,
  kycDocumentsTypesLocales,
  OFFICIAL_TAX_CERTIFICATE,
  PASSPORT,
  PASSPORT_HOST,
  PROOF_OF_ACCOMMODATION,
  PROOF_OF_ADDRESS,
  PROOF_OF_ADDRESS_HOST,
  PROXY_GRANTING,
  RESIDENCE_PERMIT_ACKNOWLEDGEMENT,
  RESIDENCE_PERMIT_RECTO,
  RESIDENCE_PERMIT_RECTO_HOST,
  RESIDENCE_PERMIT_VERSO,
  RESIDENCE_PERMIT_VERSO_HOST,
  RESIDENCY_PERMIT,
  SELFIE,
  SELFIE_WITH_ID,
  SWORN_STATEMENT,
  VIDEO,
  VISA,
} = require('./kycDocs');
const {
  getKycDocStatus,
  KYC_CATEGORIES,
  KYC_STATUSES,
  kycDocumentByCategories,
  kycDocumentTypesByCategory,
} = require('./kycDocStatus');
const {
  kycRefusalLocales,
  kycRefusalResources,
  kycRefusalTagLabel,
  kycRefusalTags,
  REFUSAL_TAGS,
} = require('./kycRefusal');
const { getFormatedErrorMessageFromTags } = require('./locales');
const {
  addTag,
  parseTags,
  removeTag,
  removeType,
  stringifyTags,
} = require('./tags');

/* eslint-disable sort-keys-fix/sort-keys-fix */
module.exports = {
  KYC_DOCUMENTS_TYPES,
  KYB_DOCUMENTS_TYPES,
  GENERIC,
  // Individual document types
  ID,
  ID_RECTO,
  ID_VERSO,
  PASSPORT,
  RESIDENCY_PERMIT,
  ID_DOCUMENT_OTHER_SHOT,
  DRIVER_LICENSE,
  PROOF_OF_ADDRESS,
  PROOF_OF_ACCOMMODATION,
  ID_HOST,
  ID_RECTO_HOST,
  ID_VERSO_HOST,
  PASSPORT_HOST,
  DRIVER_LICENSE_HOST,
  PROOF_OF_ADDRESS_HOST,
  COMPANY_REGISTRATION,
  SWORN_STATEMENT,
  BANK_IDENTITY_STATEMENT,
  PROXY_GRANTING,
  OFFICIAL_TAX_CERTIFICATE,
  BUSINESS_LEGAL_STATUS,
  SELFIE,
  VIDEO,
  RESIDENCE_PERMIT_RECTO,
  RESIDENCE_PERMIT_VERSO,
  RESIDENCE_PERMIT_ACKNOWLEDGEMENT,
  RESIDENCE_PERMIT_RECTO_HOST,
  RESIDENCE_PERMIT_VERSO_HOST,
  VISA,
  FOURTHLINE_GENERIC_ID_DOCUMENT,
  FOURTHLINE_REPORT,
  // Error Tags
  ERROR_TAGS,
  // Error messages
  GENERIC_ERROR_MESSAGES,
  // Tags utils
  parseTags,
  stringifyTags,
  addTag,
  removeTag,
  removeType,
  // Locales
  kycDocumentsTypesLocales,
  errorTagsLocales,
  genericErrorMessagesLocales,
  getFormatedErrorMessageFromTags,
  kycRefusalLocales,
  kycRefusalTagLabel,
  kycRefusalTags,
  kycRefusalResources,
  // Kyc doc status
  kycDocumentByCategories,
  getKycDocStatus,
  KYC_STATUSES,
  KYC_CATEGORIES,
  kycDocumentTypesByCategory,
  REFUSAL_TAGS,
  SELFIE_WITH_ID,
};
